export function getLabel(task_tags) {
  if (task_tags.length === 0) {
    return 'No tags selected'
  }

  return `${task_tags.length} selected`
}
